<template lang="pug">
  .type-row
    .table__row.cursor-pointer(@click="toggleBlock")
      .table__col.table__col_full-width(:style="{'border-top':'none'}")
        button.arrow.reset-btn.arrow_top(:class="{active: showBlock}")
        span {{name}}
    .table__row.cursor-pointer(v-for="(item, key) in items" @click="toggleRow(item)" v-if="showBlock" )
      .table__col.table__col_full-width.table__col_second-level(:style="{'border-top':'none'}")
        span
          button.arrow.reset-btn(:class="{active: item.opened}")
          span {{key}}
          span.red-color(style="padding-left:15px" v-html="item.percent")
        .table__children(v-if="item.opened")
          .table__row(v-for="el in item.children")
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}")
              .fkko-block.table-garbage.display-flex
                .fkko-name-wrapper.fkko-name-wrapper-garbage.fkko-block__item
                  .fkko-name {{el.fkko_name}}
                .fkko-block__item
                  span {{el.fkko_code}}
                  .reg-code.fkko-block__reg-code {{el.reg_code}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.danger}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.start_year_value}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.state}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.composition}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.production}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.tech_process}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.formed}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.count_input}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.processing}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.util}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.neutral}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.store}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.burial}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.count_output}}
            .table__col(:style="{width:`${100/Object.keys(el).length + 1 }%`, 'max-width':'270px'}") {{el.end_year_value}}
</template>

<script>
import { spliceString } from '@/utils'

export default {
  name: 'type-row',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    name: {
      type: String,
    },
    sort: {
      type: String,
    },
  },
  data: () => ({
    showBlock: false,
    items: {},
  }),
  watch: {
    $route: 'setFiltersFromUrl',
  },
  methods: {
    setFiltersFromUrl() {
      this.sortItems()
    },
    toggleBlock() {
      this.showBlock = !this.showBlock
    },
    toggleRow(item) {
      this.$set(item, 'opened', !item.opened)
      this.$forceUpdate()
    },
    sortItems() {
      for (const [key, value] of Object.entries(this.value.children)) {
        let direction = 'abc'
        let sort = this.$route.query.sort || 'fkko_name'
        if (sort[0] === '-') {
          direction = 'desc'
          sort = spliceString(sort, 0, 1)
        }
        const children = value.children.sort((a, b) => {
          if (direction === 'desc') {
            return b[sort] - a[sort]
          }
          return a[sort] - b[sort]
        })
        if (!this.items[key]) {
          this.items[key] = {
            children,
            opened: false,
            percent: this.value.children[key].percent,
          }
        } else {
          this.items[key].children = children
        }
      }
      this.$forceUpdate()
    },
  },
  created() {
    this.sortItems()
  },
}
</script>
